import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PhonesPage from "./pages/PhonesPage";
import LaptopsPage from "./pages/LaptopsPage";
import ConsoleCleaningPage from "./pages/ConsoleCleaningPage";
import MacBookCleaningPage from "./pages/MacBookCleaningPage";
import LaptopCleaningLandingPage from "./pages/LaptopCleaningLandingPage";
import IphoneRepairPage from "./pages/IphoneRepairPage";
import PCCleaningPage from "./pages/PCCleaningPage";
import AdminPage from "./pages/AdminPage";
import ContactsPage from "./pages/ContactsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import WarrantyPage from "./pages/WarrantyPage";
import { Navigate } from "react-router-dom";
import LaptopScreenRepairPage from "./pages/services/LaptopScreenRepairPage";
import PhoneScreenRepairPage from "./pages/services/PhoneScreenRepairPage";
import PhoneBatteryRepairPage from "./pages/services/PhoneBatteryRepairPage";
import LaptopHDDRepairPage from "./pages/services/LaptopHDDRepairPage";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import FacebookPixel from "./components/FacebookPixel";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AnalyticsTracker />
          <FacebookPixel />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/phones" element={<PhonesPage />} />
            <Route path="/phones/screen-repair" element={<PhoneScreenRepairPage />} />
            <Route path="/phones/battery-repair" element={<PhoneBatteryRepairPage />} />
            <Route path="/laptops" element={<LaptopsPage />} />
            <Route path="/laptops/screen-repair" element={<LaptopScreenRepairPage />} />
            <Route path="/laptops/hdd-repair" element={<LaptopHDDRepairPage />} />
            <Route path="/laptop-cleaning" element={<Navigate to="/chistka-noutbukiv" replace />} />
            <Route path="/chistka-noutbukiv" element={<LaptopCleaningLandingPage />} />
            <Route path="/chistka-macbook" element={<MacBookCleaningPage />} />
            <Route path="/remont-iphone" element={<IphoneRepairPage />} />
            <Route path="/chistka-pk" element={<PCCleaningPage />} />
            <Route path="/chistka-konsoley" element={<ConsoleCleaningPage />} />
            <Route path="/chistka-ps5" element={<ConsoleCleaningPage />} />
            <Route path="/chistka-ps4" element={<Navigate to="/chistka-konsoley" replace />} />
            <Route path="/chistka-xbox" element={<Navigate to="/chistka-konsoley" replace />} />
            <Route path="/chistka-pristavki" element={<Navigate to="/chistka-konsoley" replace />} />
            <Route path="/chistka-pristavok" element={<Navigate to="/chistka-konsoley" replace />} />
            <Route path="/macbook" element={<Navigate to="/chistka-macbook" replace />} />
            <Route path="/console-cleaning" element={<Navigate to="/chistka-konsoley" replace />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            <Route path="/garantiya" element={<WarrantyPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;